import React, { useState, useEffect } from 'react'
import { useRetorik } from '../Contexts/RetorikContext'
import { useSpeech } from '../Contexts/SpeechContext'
import { getTextWithoutSpeechMarkdown } from '../../utils/speechMarkdownUtils'

const Subtitle = (): JSX.Element | null => {
  const { displaySubtitles } = useRetorik()
  const { currentPlaying, speechAllowed } = useSpeech()
  const [textToDisplay, setTextToDisplay] = useState<string | null>(null)

  /**
   * On call :
   *  - check if the activity being played is a message
   *  - if so, call getTextWithoutSpeechMarkdown with either speak, or text, or nothing if neither is defined, and return the result
   *  - if not, return null
   * @returns string | null
   */
  const getDisplayText = (): string | null => {
    if (currentPlaying?.type === 'message') {
      const speak = currentPlaying.speak || ''
      const text = currentPlaying.text || ''

      return getTextWithoutSpeechMarkdown(speak || text || '')
    }

    return null
  }

  /**
   * On SpeechContext's currentPlaying change :
   *  - update textToDisplay state with : if there is something being played, call getDisplayText, null otherwise
   */
  useEffect(() => {
    setTextToDisplay(currentPlaying ? getDisplayText() : null)
  }, [currentPlaying])

  return textToDisplay && displaySubtitles === true && speechAllowed ? (
    <div
      className='rf-relative rf-bg-vocalModeSubtitlesBackground rf-col-start-1 vertical:rf-col-span-full rf-col-span-6 rf-row-start-9 rf-row-span-full vertical:rf-row-start-11 vertical:rf-row-span-1 rf-text-vocalModeSubtitlesText rf-justify-self-center rf-self-center rf-w-1/2 vertical:rf-w-5/6 rf-max-h-full rf-my-1 large:rf-my-4 rf-overflow-y-auto rf-scrollbar-thin rf-p-2 large:rf-p-4 rf-text-size-auto rf-text-center'
      id='retorik-subtitles'
      dangerouslySetInnerHTML={{ __html: textToDisplay }}
    />
  ) : null
}

export default Subtitle
